<template>
  <div class="ab-box">
    <Nav></Nav>
    <div id="h" class="w">
      <Heade></Heade>
    </div>
    <div class="bannerBox">
      <img src="../assets/aboutus/banner-02.png" alt />
    </div>
    <div class="ab-count">
      <div class="w">
        <el-container>
          <el-container>
            <el-aside width="200px">
              <el-menu
                class="el-menu-vertical-demo"
                :default-active="active"
                unique-opened
                active-text-color="#a77c5a"
              >
                <!-- <div index="/backshouye" class="li-yunshan">
                  <img src="../assets/aboutus/yunzhongxin.png" />
                  <span>&nbsp;云闪印中心</span>
                </div> -->
                <el-submenu :index="index+''" v-for="(item,index) in cateNewData" :key="index">
                  <template slot="title">
                    <i class="el-icon-tickets"></i>
                    <span>{{item.cate_name}}</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item
                      :index="item1.id+''"
                      v-for="(item1,index1) in item.list"
                      :key="index1"
                      @click="goNew(item1.id,item1.title)"
                    >{{item1.title}}</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
            </el-aside>
            <el-container>
              <el-main>
                <div class="content_tit"></div>
                <div class="content_text"></div>
              </el-main>
            </el-container>
          </el-container>
        </el-container>
      </div>
    </div>
    <Fotter></Fotter>
  </div>
</template>

<script>
import Nav from '../components/index/nav'
import Heade from '../components/index/head'
import Fotter from '../components/index/fotter'

export default {
  components: {
    Nav,
    Heade,
    Fotter
  },
  data() {
    return {
      cateNewData: [],
      contentText: [],
      headerList: {},
      newName: '',
      newId: '',
      active: '',
      logoUlr: '',
      url: window.location.href
    }
  },
  methods: {
    // 获取header数据
    async queryList() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: '/api/page/nav',
        data: param
      })
      JSON.stringify(res.data) !== []
        ? (this.headerList = res.data)
        : (this.headerList = {})
    },
    async queryCateNews() {
      const { data: res } = await this.$http.get('api/index/getnewscate')
      if (res.code) {
        this.cateNewData = res.data
        if (this.url.indexOf('?') === -1) {
          this.active = this.cateNewData[0].list[0].id + ''
          this.newId = this.active
          this.queryContent()
        }
      }
    },
    goNew(id, title) {
      this.newId = id
      this.newName = title
      this.$router.push('/aboutour?id=' + id)
    },
    async queryContent() {
      let param = new URLSearchParams()
      param.append('id', this.newId)
      const { data: res } = await this.$http.post('api/index/getnewsxq', param)
      if (res.code) {
        $('.content_tit').text(res.data[0].title)
        $('.content_text').html(res.data[0].content)
      }
    }
  },

  created() {
    this.queryCateNews()
    this.queryList()
    let sy_info = window.sessionStorage.getItem('sy_info')
    this.logoUlr = JSON.parse(sy_info).logo
  },
  mounted() {
    if (this.url.indexOf('?') !== -1) {
      this.newId = this.url.substr(this.url.indexOf('?') + 4)
      this.active = this.newId
      this.queryContent()
    }
    if (window.sessionStorage.getItem('n')) {
      this.newName = window.sessionStorage.getItem('n')
      window.sessionStorage.removeItem('n')
    }
  },
  watch: {
    $route(to, from) {
      let url = window.location.href
      this.newId = url.substr(url.indexOf('?') + 4)
      this.active = this.newId
      this.queryContent()
    }
  }
}
</script>

<style lang="less" scoped>
.el-aside {
  min-height: 700px;
  background: #fff;
}
#h {
  height: 140px;
  overflow: hidden;
}
.ab-count {
  width: 100%;
  position: relative;
  margin-top: 20px;
}
.content_tit {
  font-size: 24px;
}
.content_text {
  padding: 20px 30px;
}
.li-yunshan {
  background: rgba(16, 176, 100, 1);
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  box-sizing: border-box;
}
.el-main {
  margin-left: 10px;
  min-height: 600px;
  background-color: #fff;
}
.bannerBox{
  text-align: center;
}
</style>